import { render } from "./TokenMethod.vue?vue&type=template&id=2114390c"
import script from "./TokenMethod.vue?vue&type=script&lang=js"
export * from "./TokenMethod.vue?vue&type=script&lang=js"

import "./TokenMethod.vue?vue&type=style&index=0&id=2114390c&lang=css"
script.render = render

export default script